import React, { FC } from 'react';
import styles from './entity_decision_list_modal.module.scss';
import { MaterialIcon } from '../../components/material-icon/MaterialIcon';

type Props = {
  title: string;
  subtitle: string;
  onGoBack: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onClose: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

export const EntityDecisionListModalHeaderGoBack: FC<Props> = ({
  title,
  subtitle,
  onGoBack,
  onClose,
}) => (
  <div className={styles.containerGoBack}>
    <div className={styles.goBack} onClick={onGoBack}>
      <MaterialIcon name="arrow_back" />
    </div>
    <div className={styles.textContainer}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
    </div>

    <div className={styles.close} onClick={onClose}>
      <MaterialIcon name="close" />
    </div>
  </div>
);
